import GlobalOutlined from "@ant-design/icons/GlobalOutlined";
import { Globe } from "lucide-react";
import LookIcon from "common/Icons/LookIcon.tsx";
import IconButton from "common/Buttons/IconButton.tsx";
import Popover from "common/Popover/Popover.tsx";
import styled from "styled-components";
import LanguageSelector from "common/Home/Header/LanguageSelector.tsx";

const LanguageSelectorPopover = () => {
  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      content={
        <LanguageSelectorWrapper>
          <LanguageSelector />
        </LanguageSelectorWrapper>
      }
    >
      <IconButton
        icon={
          <LookIcon
            classic={<GlobalOutlined style={{ fontSize: 22 }} />}
            newLook={<Globe size={20} strokeWidth={1.75} />}
          />
        }
      />
    </Popover>
  );
};

export default LanguageSelectorPopover;

const LanguageSelectorWrapper = styled.div`
  min-width: 190px;
`;
